

















































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { downloadfile, downloadpdf } from '@/api/declare'
import {
  gettpoiclist,
  getExpertNum,
  getRandomList,
  addExperts,
  getExpertsList,
  getExpertReview
} from '@/api/tissuemanage'
import { getdatalist } from '@/api/expertTank'
import Pagination from '@/components/Pagination/index.vue'
import moment from 'moment'
import { saveOrUpdate, getOptionInfo } from '@/api/proofSheet'
@Component({
  name: 'guideManage',
  components: { Pagination }
})
export default class extends Vue {
  [x: string]: any;
  // [x: string]: any;
  mounted() {
    this.getList(this.listQuery)
    this.getYearList()
    this.baseurl = (window as any).downloadurl
    this.listQuery.userid = window.sessionStorage.getItem('id')
    this.listQuery.role = Number(window.sessionStorage.getItem('role'))
  }
  private currtentpage = 1;
  private baseurl = ''
  private total: number = 0;
  private topicrole = '';
  private shstate = '';
  private selectVal = ''
  private isShowBtn = true
  private expertQuery:any = {
    pageNum: 1,
    pageSize: 10,
    param: '',
    randomNum: 0,
    topicIds: []
  }
  // 上传审批意见的参数
  private ruleForm = {
    option: '该课题建议定级为：（A级/B级/C级/D级）\n' +
      '理由如下：',
    score: '',
    visible: false,
    topicId: ''
  }
  // 综合评审请求参数
  private expertcomQuery = {
    name: '',
    page: 1,
    limit: 10
  }
  private formObj:any = {
    title: '',
    expertVis: false,
    number: '', // 选中的人数
    addExoertVis: false, // 添加评审专家模态框
    searcVal: '', // 添加评审专家查询名称
    expertList: [], // 专家数组
    tableData: [], // 添加评审专家数据源
    total: 0,
    currentPage: 1,
    multipleSelection: [], // 添加专家页面复选多个数据
    comExpertVis: false, // 指定综合评审专家
    addcomExoertVis: false, // 指定专家评审页面
    comTableData: [],
    topicId: '' // 课题id
  };
  private zjhzForm:any = {
    visible: false,
    maxNum: 0,
    minNum: 0,
    average: 0,
    level: '',
    infoList: []
  }
  // 选择人数下拉框
  private options = [
    {
      value: '1',
      label: '1'
    },
    {
      value: '2',
      label: '2'
    },
    {
      value: '3',
      label: '3'
    },
    {
      value: '4',
      label: '4'
    },
    {
      value: '5',
      label: '5'
    }
  ]
  private usestate = [
    {
      value: 1,
      label: '启用'
    },
    {
      value: 0,
      label: '禁用'
    }
  ];
  private roleoptions = [
    {
      label: '中心选题',
      value: 0
    },
    {
      label: '自主选题',
      value: 1
    }
  ];
  private scoreRules ={
    option: [
      { required: true, message: '请输入评分意见', trigger: 'blur' }
    ],
    score: [
      { required: true, message: '请输入评分', trigger: 'blur' }
    ]
  }
  private stateoptions = [
    {
      label: '待审核',
      value: '-2'
    },
    {
      label: '审核通过',
      value: '-3'
    },
  ];
  private tableData:any = [];
  private name = '';
  private isloading = true;
  private listQuery:any = {
    level: -1,
    limit: 10,
    name: '',
    num: '',
    page: 1,
    state: -1,
    topictype: -1,
    userid: '',
    role: 0,
    expertRole: ''
  };
  //andy 增加查询条件
  private declarername = null //申报人姓名
  private subjectnumber = null //课题编号
  private year = null //年度
  private yearlist : any [] = []
  //andy 增加年度查询条件
  private clearyear() {
    this.listQuery.year = null
    this.getList(this.listQuery)
  }
  private changeyear(val) {
    if (val != null) {
      this.listQuery.year = val
    }
    this.getList(this.listQuery)
  }

  // 表单校验规则
  private rules = {
    name: [
      { required: true, message: '请输入组织名称', trigger: 'blur' }
      // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
    ],
    description: [
      { required: true, message: '请输入备注内容', trigger: 'blur' }
      // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
    ],
    number: [{ required: true, message: '请输入组织编号', trigger: 'change' }]
  };

  // 获取列表
  private async getList(params: any) {
    await gettpoiclist(params)
      .then((res) => {
        if (res.code === 200) {
          this.tableData = res.data.itemBeanList[0]
          this.total = res.data.total
          this.isloading = false
        }
      })
      .catch(() => {
        // this.list = [];
        // this.listLoading = false;
      })
  }
  private cleardata() {
    this.listQuery.state = -1
    this.getList(this.listQuery)
  }
  private prints(item) {
    let prints:any = document.getElementById('maincard')
    prints.title = item.name
  }
  async changestate(val) {
    if (val == null) {
      this.listQuery.state = -1
    } else {
      this.listQuery.state = val
    }
    await gettpoiclist(this.listQuery)
      .then((res) => {
        if (res.code === 200) {
          let copeData = res.data.itemBeanList[0]
          this.total = res.data.total
          this.tableData = []
          this.isloading = false
          if (val === '-2') {
            copeData.forEach((res:any) => {
              if (res.average === null) {
                this.tableData.push(res)
              }
            })
          } else {
            this.tableData = res.data.itemBeanList[0]
          }
        }
      })
  }
  private changerole(val) {
    if (val === '') {
      this.listQuery.topictype = -1
    } else {
      this.listQuery.topictype = val
    }
    this.getList(this.listQuery)
  }
  private onSubmit() {
    this.listQuery.page = 1
    this.listQuery.name = this.name
    // listQuery.state = -2的时候 返回专家评审完成的数据和专家评审中的数据 页面只显示专家评审中的数据
    if (this.listQuery.state === '-2') {
      this.changestate(this.listQuery.state)
    } else {
      this.getList(this.listQuery)
    }
  }
  private clearSearch() {
    this.listQuery = {
      expertRole: '',
      role: 3,
      level: -1,
      limit: 10,
      name: '',
      num: '',
      page: 1,
      state: -1,
      topictype: -1,
      userid: window.sessionStorage.getItem('id')
    }
    this.name = ''
    this.topicrole = ''
    this.shstate = ''
    this.year = null
    this.getList(this.listQuery)
  }
  private watchitem(params, row) {
    this.$router.push({ path: '/declare/declare' })
    let topicinfo: any = JSON.stringify(row)
    window.sessionStorage.setItem('topicid', JSON.stringify(params))
    window.sessionStorage.setItem('iswatch', 'true')
    window.sessionStorage.setItem('ishandle', 'true')
    window.sessionStorage.setItem('topicinfo', topicinfo)
    let time = row.createtime.substring(0, 4)
    window.sessionStorage.setItem('time', time)
  }
  private async editLineItem(params: any) {
    this.ruleForm.visible = true
    this.isShowBtn = true
    this.ruleForm.topicId = params.id
    let param = {
      topicId: params.id,
      userId: window.sessionStorage.getItem('id')
    }
    getOptionInfo(param).then((res) => {
      if (res.code === 200) {
        this.ruleForm.score = res.data.score
        if (res.data.opinion === null) {
          this.ruleForm.option = '该课题建议定级为：（A级/B级/C级/D级）\n' +
            '理由如下：'
        } else {
          this.ruleForm.option = res.data.opinion
        }
      }
    })
  }
  closeComExpert() {
    this.zjhzForm.visible = false
  }
  watchResult(val) {
    this.isShowBtn = false
    let parma = {
      topicId: val,
      userId: window.sessionStorage.getItem('id')
    }
    getOptionInfo(parma).then((res) => {
      if (res.code === 200) {
        this.ruleForm.visible = true
        this.isShowBtn = false
        this.ruleForm.score = res.data.score
        this.ruleForm.option = res.data.opinion
      }
    })
  }
  loadNumber(val) {
    console.log(val)
    // var elValue = val
    // var reg = /^((?!0)\d{1,2})$/;
    // if (!reg.test(elValue)) {
    //   val = ''
    // }
    // return val
  }
  // 查看线上pdf
  WatchLineItem(id,row) {
    let sbdata: any = {} // 申报对象集合
    let param = {
      id: id
    }

    downloadpdf(param).then((res) => {
      if (res.code === 200) {
        // state 0未生成 1生成中 2已生成
        let data_ = res.data
        data_.forEach((res) => {
          // res.type=0 完整版pdf  =1预算pdf
          if (res.type === 0) {
            sbdata = res
          }
        })
        if (sbdata.state === 0) {
          this.$message.warning('申报表暂未生成，请生成后查看')
        } else if (sbdata.state === 1) {
          this.$message.warning('申报表正在生成中,请稍后查看')
        } else {
          let href_ = '/pdf/' + sbdata.url.split(',').pop()
          const { href } = this.$router.resolve({ path: "/proofSheet", query: { url: href_ } })
          // this.$router.push('/proofSheet')
          window.open(href)
        }
      }
    })
  }
  editLineBotItem(params: any, row: any) {
    let topicinfo: any = JSON.stringify(row)
    window.sessionStorage.setItem('topicid', JSON.stringify(params))
    window.sessionStorage.setItem('iswatch', 'true')
    window.sessionStorage.setItem('topicinfo', topicinfo)
    window.sessionStorage.removeItem('ishandle')
    let time = row.createtime.substring(0, 4)
    window.sessionStorage.setItem('time', time)
    // isrefuse=1的时候是预算驳回后重新上传的状态 declare页面显示预算驳回后的表格
    if (row.isrefuse === 1) {
      window.sessionStorage.setItem('isrefuse', 'true')
    } else {
      window.sessionStorage.removeItem('isrefuse')
    }
    // const { href } = this.$router.resolve({ path: "/declare/declare" });
    // window.open(href, "_blank");
    this.$router.push({ path: '/expertLine/expertLine' })
  }
  downfile(type_, row) {
    let param = {
      id: row.id
    };
    let sbdata: any = {} // 申报对象集合
    let ysdaya: any = {} // 预算对象集合
    downloadpdf(param).then((res) => {
      if (res.code === 200) {
        // state 0未生成 1生成中 2已生成
        let data_ = res.data
        data_.forEach((res) => {
          // res.type=0 完整版pdf  =1预算pdf
          if (res.type === 0) {
            sbdata = res
          } else {
            ysdaya = res
          }
        })
        if (type_ === 0) {
          if (sbdata.state === 0) {
            this.$message.warning('申报表暂未生成，请先生成后下载')
          } else if (sbdata.state === 1) {
            this.$message.warning('申报表正在生成中,请稍后下载')
          } else {
            var x = new XMLHttpRequest()
            // sbdata.url字符串前面的是完整版申报pdf 后面的是论证活页的pdf
            let href = this.baseurl + 'pdf/' + sbdata.url.split(',').shift()
            x.open('GET', href, true)
            x.responseType = 'blob'
            x.onload = function(e) {
              var url = window.URL.createObjectURL(x.response)
              var a = document.createElement('a')
              a.href = url
              if (row.name == null) {
                a.download = '申报表'
              } else {
                a.download =
                  '申请书_' +
                  row.name +
                  '_' +
                  moment(new Date()).format('YYYY-MM-DD HH-MM-ss')
              }
              a.click()
            }
            x.send()
          }
        } else if (type_ === 1) {
          if (ysdaya.state === 0) {
            this.$message.warning('预算表暂未生成，请先生成后下载')
          } else if (ysdaya.state === 1) {
            this.$message.warning('预算表正在生成中,请稍后下载')
          } else {
            let href = this.baseurl + '/pdf/' + ysdaya.url
            var x = new XMLHttpRequest()
            x.open('GET', href, true)
            x.responseType = 'blob'
            x.onload = function(e) {
              var url = window.URL.createObjectURL(x.response)
              var a = document.createElement('a')
              a.href = url
              if (row.name == null) {
                a.download = '预算表'
              } else {
                a.download = row.name + '预算表'
              }
              a.click()
            }
            x.send()
          }
        } else {
          if (sbdata.state === 0) {
            this.$message.warning('论证活页暂未生成，请先生成后下载')
          } else if (sbdata.state === 1) {
            this.$message.warning('论证活页正在生成中,请稍后下载')
          } else {
            let href = this.baseurl + 'pdf/' + sbdata.url.split(',').pop()
            var x = new XMLHttpRequest()
            x.open('GET', href, true)
            x.responseType = 'blob'
            x.onload = function (e) {
              var url = window.URL.createObjectURL(x.response)
              var a = document.createElement('a')
              a.href = url
              if (row.name == null) {
                a.download = '论证活页'
              } else {
                a.download =
                  '论证活页_' +
                  row.name +
                  '_' +
                  moment(new Date()).format('YYYY-MM-DD HH-MM-ss')
              }
              a.click()
            }
            x.send()
          }
        }
      }
    })
  }
  watchfile(type_, row) {
    let param = {
      id: row.id
    };
    let sbdata: any = {} // 申报对象集合
    let ysdaya: any = {} // 预算对象集合
    downloadpdf(param).then((res) => {
      if (res.code === 200) {
        // state 0未生成 1生成中 2已生成
        let data_ = res.data
        data_.forEach((res) => {
          // res.type=0 完整版pdf  =1预算pdf
          if (res.type === 0) {
            sbdata = res
          } else {
            ysdaya = res
          }
        })
        if (type_ === 0) {
          if (sbdata.state === 0) {
            this.$message.warning('申报表暂未生成，请先生成后下载')
          } else if (sbdata.state === 1) {
            this.$message.warning('申报表正在生成中,请稍后下载')
          } else {
            var x = new XMLHttpRequest()
            let href = this.baseurl + 'pdf/' + sbdata.url
            x.open('GET', href, true)
            x.responseType = 'blob'
            x.onload = function(e) {
              var url = window.URL.createObjectURL(x.response)
              var a = document.createElement('a')
              a.href = url
              a.target = '_blank'
              // if (row.name == null) {
              //   a.download = "申报表";
              // } else {
              //   a.download = row.name + "申报表";
              // }
              a.click()
            }
            x.send()
          }
        } else {
          if (ysdaya.state === 0) {
            this.$message.warning('预算表暂未生成，请先生成后下载')
          } else if (ysdaya.state === 1) {
            this.$message.warning('预算表正在生成中,请稍后下载')
          } else {
            let href = this.baseurl + '/pdf/' + ysdaya.url
            let url = window.URL.createObjectURL(href)
            const savea = document.createElement('a')
            savea.download = 'sss'
            if (row.name == null) {
              savea.download = '预算表'
            } else {
              savea.download = row.name + '预算表'
            }
            savea.href = url
            savea.click()
          }
        }
      }
    })
  }
  private handleClose() {
    this.formObj.expertVis = false
    this.ruleForm.visible = false
  }

  // 分页
  private handleSizeChange(val: number) {
    this.listQuery.limit = val
    this.getList(this.listQuery)
  }
  private handleCurrentChange(val: number) {
    this.listQuery.page = val
    this.getList(this.listQuery)
  }
  private expertSizeChange(val) {
    this.expertQuery.pageSize = val
    this.getExpertList(this.expertQuery)
  }
  private expertCurrentChange(val) {
    this.expertQuery.pageNum = val
    this.getExpertList(this.expertQuery)
  }
  private expertcomSize(val) {
    this.expertcomQuery.limit = val
  }
  private expertcomPage(val) {
    this.expertcomQuery.page = val
  }
  private cellStyle({
    row,
    column,
    rowIndex,
    columnIndex
  }: {
    row: any;
    column: any;
    rowIndex: any;
    columnIndex: any;
  }) {
    return 'text-align:center'
  }

  private rowClass({ row, rowIndex }: { row: any; rowIndex: any }) {
    return 'text-align:center'
  }
  // 指定专家模态框
  private giveExperst(val) {
    this.formObj.expertVis = true
    this.selectVal = ''
    this.formObj.title = '指定评审专家'
    this.formObj.topicId = val.id
    let param:any = {
      type: 1, // 1线上专家 2线下专家
      topicIds: []
    }
    param.topicIds.push(this.formObj.topicId)
    getExpertsList(param).then((res) => {
      this.formObj.expertList = res.data
    })
  }
  // 指定专家组长
  private giveLeader() {
    this.zjhzForm.visible = true
    this.formObj.title = '指定专家组长'
  }
  // 随机抽取人数
  choosePerson() {
    let param:any = {
      pageNum: 1,
      pageSize: 10,
      param: '',
      topicIds: []
    }
    param.randomNum = Number(this.selectVal)
    param.topicIds.push(this.formObj.topicId)
    getRandomList(param).then((res) => {
      if (res.code === 200) {
        this.formObj.expertList = this.formObj.expertList.concat(res.data)
        let newObj = {}
        this.formObj.expertList = this.formObj.expertList.reduce((cur, next) => {
          newObj[next.id] ? '' : newObj[next.id] = true && cur.push(next)
          return cur
        }, [])
      } else if (res.code === 417) {
        this.$message.warning(res.message)
      }
    })
  }
  // 提交分数的页面
  submitForm() {
    (this.$refs.agreeform as any).validate((valid) => {
      if (valid) {
        let param:any = {
          opinion: this.ruleForm.option,
          score: Number(this.ruleForm.score),
          topicId: this.ruleForm.topicId,
          userId: window.sessionStorage.getItem('id')
        }
        saveOrUpdate(param).then((res) => {
          if (res.code === 200) {
            this.$message.success('专家意见保存成功')
            this.ruleForm.visible = false
            this.getList(this.listQuery)
          }
        })
      } else {
        return false
      }
    })
  }
  // 添加评审专家
  addPerson() {
    this.formObj.addExoertVis = true
    this.formObj.title = '添加评审专家'
    this.expertQuery.topicIds.push(this.formObj.topicId)
    this.getExpertList(this.expertQuery)
  }
  // 指定线上专家 查询列表
  getExpertList(val) {
    getdatalist(val)
      .then((res) => {
        if (res.code === 200) {
          this.formObj.tableData = res.data.records
          this.formObj.total = res.data.total
        }
      })
  }
  // 从指定综合评审专家进入的添加评审专家
  addcomPerson() {
    this.formObj.addExoertVis = true
    getdatalist(this.expertcomQuery)
      .then((res) => {
        if (res.code === 200) {
          this.formObj.comTableData = res.data.list
          this.formObj.total = res.data.total
        }
      })
  }
  // 提交专家
  submitExperts() {
    let param:any = []
    let obj:any = {
      expertIds: [],
      topicId: this.formObj.topicId,
      type: 1
    }
    this.formObj.expertList.forEach((res) => {
      obj.expertIds.push(res.id)
    })
    param.push(obj)
    addExperts(param).then((res) => {
      if (res.code === 200) {
        this.$message.success('课题绑定线上专家成功')
        this.formObj.expertVis = false
      }
    })
  }
  // 提交选择专家
  submitchooseExperts() {
    this.formObj.expertList = this.formObj.expertList.concat(this.formObj.multipleSelection)
    let newObj = {}
    this.formObj.expertList = this.formObj.expertList.reduce((cur, next) => {
      newObj[next.id] ? '' : newObj[next.id] = true && cur.push(next)
      return cur
    }, [])
    this.formObj.addExoertVis = false
    this.formObj.title = '指定评审专家'
  }
  expertSize(val) {
    this.expertQuery.limit = val
    this.addPerson()
  }
  expertPage(val) {
    this.expertQuery.page = val
    this.addPerson()
  }
  // 添加专家复选框
  handleSelectionChange(val) {
    val.forEach((res) => {
      let obj:any = {
        id: res.id,
        employer: res.employer,
        name: res.name
      }
      this.formObj.multipleSelection.push(obj)
    })
  }
  closeExperts() {
    this.formObj.addExoertVis = false
  }
  // 删除指定专家
  removeChoose(index) {
    this.formObj.expertList.splice(index, 1)
    this.searcVal = String(this.formObj.expertList.length)
  }
  // 查询专家评审汇总
  getExpertScore(val) {
    this.zjhzForm.visible = true
    this.zjhzForm.infoList = []
    let param = {
      topicId: val.id
    }
    getExpertReview(param).then((res) => {
      if (res.code === 200) {
        this.zjhzForm.maxNum = res.data.maxScore
        this.zjhzForm.minNum = res.data.minScore
        this.zjhzForm.average = res.data.average
        this.zjhzForm.name = val.name
        this.zjhzForm.topicUser = val.headname
        res.data.infoList.forEach((res) => {
          if (res.score !== null && res.idea !== null) {
            this.zjhzForm.infoList.push(res)
          }
        })
      }
    })
  }
  claseZjhz() {
    this.zjhzForm.visible = false
  }
  // 上传文件
  uploadPzfile() {

  }
  // andy 
  getYearList() {
    let d = new Date();
    let year = d.getFullYear();
    for (let index = 2021; index <= year; index++) {
      this.yearlist.unshift(index)
    }
  }
}
